import router from '@/router'
import store from '@/store'
import globalMixin from '@/mixins'

export function amountFormat (amount) {
  amount = parseFloat(amount)
  if (typeof amount === 'number' && !isNaN(amount)) {
    return amount.toLocaleString('en-IN', {style: 'currency', currency: 'INR', minimumFractionDigits: 1, maximumFractionDigits: 2})
  } else {
    return ''
  }
}

export function onScroll (paginate, populateData, list) {
  if (paginate.total > paginate.start + paginate.page_size) {
    let appearOnScroll = new IntersectionObserver((entries, appearOnScroll) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          populateData(paginate.start += paginate.page_size)
          appearOnScroll.unobserve(entry.target)
        }
      })
    })

    let tableRows = null
    if (list) {
      tableRows = document.querySelectorAll(list)
    } else {
      tableRows = document.querySelectorAll('.table-body .table-row')
    }

    let lastRow = tableRows.length - 1
    appearOnScroll.observe(tableRows[lastRow])
  }
}

export function goBack () {
  if (store.state.global.initialHistory - window.history.length > 2) {
    router.go(-1)
  } else {
    router.push({name: router.currentRoute.meta.parentRoute})
  }
}

export function openPopup (popup) {
  store.commit('SET_POPUP_NAME', popup)
}

export function capitalize (key) {
  return key.charAt(0).toUpperCase() + key.slice(1)
}

export function capitalizeByDelimiter (key, delimiter = '_') {
  return key.split(delimiter).map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(' ')
}

export function copyText (copiedText, tooltipOptions) {
  let textArea = document.createElement('textarea')
  textArea.value = copiedText
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)

  let successText = (tooltipOptions && tooltipOptions.text) ? tooltipOptions.text : 'Copied to clipboard'
  if (tooltipOptions && tooltipOptions.selector) {
    let tooltipElem = document.createElement('p')
    tooltipElem.id = 'ClipboardTooltip'
    tooltipElem.appendChild(document.createTextNode(successText))

    let targetElem = document.querySelector(tooltipOptions.selector)
    targetElem.appendChild(tooltipElem)

    setTimeout(() => {
      targetElem.removeChild(tooltipElem)
    }, 3000)
  } else {
    globalMixin.methods.successToastMsg(successText)
  }
}

export function setDropdownPosOffset (id) {
  let pos = document.querySelector(`#${id} .md-select`).getBoundingClientRect()
  let menus = document.querySelector('.md-select-menu')

  setTimeout(() => {
    menus.style.maxWidth = 'none'
    menus.style.width = pos.width + 'px'
    menus.style.left = pos.x + 'px'
    menus.style.top = pos.y + pos.height + 'px'
  })
}

export function checkFormErrors (formErrors) {
  for (let error in formErrors) {
    if (formErrors[error].length) {
      return true
    }
  }
  return false
}

export function clearFormErrors (formErrors) {
  for (let error in formErrors) {
    formErrors[error] = []
  }
}

export function allowAmountFormat ($event, amount) {
  if (!amount) {
    amount = ''
  }
  const pos = $event.target.selectionStart
  amount = amount.slice(0, pos) + $event.key + amount.slice(pos)
  if (!(/^[0-9]{0,8}(\.[0-9]{0,2})?$/).test(amount)) {
    $event.preventDefault()
  }
}

export function allowOnlyNumbers ($event) {
  if (!/^[0-9]$/.test($event.key)) {
    $event.preventDefault()
  }
}

export function pluralize (data, count) {
  return (count === 1) ? data : (data.endsWith('y')) ? data.slice(0, -1) + 'ies' : data + 's'
}
